import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { BannerService } from '../../../services/banner/banner.service';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';

import { CarritoService } from '../../../services/carrito/carrito.service';
import { ProductoService } from '../../../services/producto/producto.service';

import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import { IProducto } from '../../../../model/interface/IProducto';
import * as _ from 'lodash';

import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  animations: [
    trigger('visibility-map', [
      state('in', style({
        'top': '40px'
      })),
      state('out', style({
        'top': '-450px'
      })),
      transition('in => out', animate('300ms ease-in')),
      transition('out => in', animate('300ms ease-out'))
    ]),
    trigger('visibility-car', [
      state('in', style({
        'opacity': '1',
        'display': 'block'
      })),
      state('out', style({
        'opacity': '0',
        'display': 'none'
      })),
      transition('in => out', animate('300ms ease-in')),
      transition('out => in', animate('300ms ease-out'))
    ])
  ]
})
export class NavbarComponent implements OnInit {

  statusMap = 'out';
  statusCar = 'out';
  carroProductos: ElementoCarro[] = [];
  textoBuscar: string;
  searchResultsIsOpen: boolean;
  textoBuscarChanged: Subject<string> = new Subject<string>();
  cargandoBusqueda = true;
  banner: any;

  productosBusqueda: IProducto[] = [];
  bannersParams: any;

  constructor(
    private _carritoService: CarritoService,
    private _productoService: ProductoService,
    private _bannerService: BannerService,
    private _router: Router,
    private renderer: Renderer2
  ) {
    this.bannersParams = {'per_page': 1};

    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();

        if (this.textoBuscar === '') {
          this.productosBusqueda = [];
          this.cargandoBusqueda = false;
        } else {
          this.buscarProducto();
        }
      });
  }

  varMapa() {
    this.statusMap = this.statusMap === 'out' ? 'in' : 'out';
  }

  toogleCar() {
    this.statusCar = this.statusCar === 'in' ? 'out' : 'in';
  }

  onClickedOutside(event) {
    if (['remove-item-two', 'delete-item', 'remove-item'].indexOf(event.path[0].id) === -1) {
      this.statusCar = 'out';
    }
  }

  ngOnInit() {

    this.textoBuscar = '';
    this.searchResultsIsOpen = false;

    this._carritoService.carroProductos.subscribe(carro => {

      if (carro) {
        this.carroProductos = carro;
      }

    } );

    this._bannerService.getActivosPorTipo('CONTACTO', this.bannersParams)
      .subscribe( resp => {
        this.banner = resp.data[0];
      });

  }



  buscarProducto () {

    // this.textoBuscar = _.trim(this.textoBuscar);

    let texto =  this.textoBuscar.replace(new RegExp('span', 'ig'), '');
    texto = _.trim(texto);

    if (texto.length > 0) {

      const objetoBucar: any[] = [{'name': texto}];
      const parametros = {search: JSON.stringify(objetoBucar)};

      this._productoService.getPublicados(parametros)
        .subscribe( data => {
          this.productosBusqueda = data;
          this.cargandoBusqueda = false;
        });
    } else {
      this.productosBusqueda = [];
      this.cargandoBusqueda = false;
    }
  }

  limpiarTexto () {
    this.productosBusqueda = [];
    this.textoBuscar = '';
    this.searchResultsIsOpen = false;
    this.renderer.removeClass(document.body, 'with-overlay');
  }


  onTextoBuscarChange(texto: string) {
    this.cargandoBusqueda = true;
    this.searchResultsIsOpen = true;
    this.textoBuscarChanged.next(texto);
  }

  agregarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

  eliminarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.eliminarProducto(clon);
  }

  goToProduct(idProduct: number) {
    this.statusCar = 'out';
    this._router.navigate(['/producto', idProduct]);
  }


  goToResultadosBusqueda() {
    const texto = this.textoBuscar;
    this.limpiarTexto();
    this._router.navigate(['/resultado-busqueda', texto]);

  }

  goToProducto(idProducto: number) {
    this.limpiarTexto();
    this._router.navigate(['/producto', idProducto]);
  }

  goToCotizar() {
    this.statusCar = 'out';
    this._router.navigate(['/cotizaciones']);
  }

}




// WEBPACK FOOTER //
// /app/src/app/components/structure/navbar/navbar.component.ts